import React from "react";
import StatusApplication from "./StatusApplication";
import { checkPermission, permissionsConfig } from '../AdminPermission/PermissionChecker';

const PaymentDocumentRejectedRenewApplications = () => {
  const editApplicationPermission = checkPermission(
    permissionsConfig.editRenewPaymentDocumentRejectedApplications.role,
    permissionsConfig.editRenewPaymentDocumentRejectedApplications.action,
    permissionsConfig.editRenewPaymentDocumentRejectedApplications.type
  );
    
  const deleteApplicationPermission = checkPermission(
    permissionsConfig.deleteRenewPaymentDocumentRejectedApplications.role,
    permissionsConfig.deleteRenewPaymentDocumentRejectedApplications.action,
    permissionsConfig.deleteRenewPaymentDocumentRejectedApplications.type
  );
  
  return (
    <StatusApplication appStatus="11" title="Payment Document Rejected" subTitle="Payment Document Rejected" application_type="1" pageFrom="renew/rejected" editApplicationPermission={editApplicationPermission} deleteApplicationPermission={deleteApplicationPermission}></StatusApplication>
  )
}

export default PaymentDocumentRejectedRenewApplications